<template>
    <div>
        <label for="paises">{{ $t('formularios.pais') }}</label>
        <ValidationProvider name="paises" id="paises" rules="required" v-slot="{ errors }">
            <multiselect
                :disabled="desactivar"
                v-model="selected"
                :placeholder="$t('formularios.pais')"
                label="nombre"
                track-by="id"
                :options="paises"
                :multiple="false"
                v-on:select="(selectedOpt) => $emit('selected', selectedOpt)"
            />
            <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ errors[0] }}</b></span>
        </ValidationProvider>
    </div>
</template>

<script>

    export default {
        props: {
            pais: {
                type: Object,
                default: null
            },
            desactivar: {
                type: Boolean,
                default: false
            },
            errors: {
                type: Array,
                default: () => []
            }

        },
        data() {
            return {
                paises: [],
                selected: null
            }
        },
        created() {
            this.getPaises();
        },
        computed: {
        },
        methods: {
            findPais(pais) {
                if (!pais || !this.paises.length) return null;
                // Match by id first
                if (pais.id) {
                    const foundById = this.paises.find(p => p.id === pais.id);
                    if (foundById) return foundById;
                }
                // Match by nombre (string or object property)
                const nombre = typeof pais === 'string' ? pais : pais.nombre;
                if (nombre) {
                    const foundByName = this.paises.find(p =>
                        p.nombre && p.nombre.toLowerCase() === nombre.toLowerCase()
                    );
                    if (foundByName) return foundByName;
                }
                // Fallback: match by iso3 or iso2 code
                const iso3 = pais.iso3 || pais.iso2 || (typeof pais === 'string' && pais.length <= 3 ? pais : null);
                if (iso3) {
                    const foundByIso = this.paises.find(p =>
                        (p.iso3 && p.iso3.toLowerCase() === iso3.toLowerCase()) ||
                        (p.iso2 && p.iso2.toLowerCase() === iso3.toLowerCase())
                    );
                    if (foundByIso) return foundByIso;
                }
                return null;
            },
            getPaises() {
                this.$store.dispatch(this.config.getVuexAlias('select.paises')).then(res => {
                    this.paises = res.data.data;

                    if (this.pais) {
                        this.selected = this.findPais(this.pais);
                    }

                    if (!this.selected) {
                        this.selected = this.paises[67]; // Default Spain
                    }

                    this.$emit('rellenarPais', this.selected)
                    this.$emit('paisesCargados', this.paises);
                });
            }
        }
    }
</script>
